module.exports = __webpack_public_path__ + "img/arrowToRight.a47e0872.svg";